module.exports = __webpack_public_path__ + "78306c850c72557900b5d8b42ba479fa.svg";